import { Auth } from 'aws-amplify';

export const getSessionTokens = async () => {
    const session = await Auth.currentSession();

    return {
        idToken: session.getIdToken().getJwtToken(),
        accessToken: session.getAccessToken().getJwtToken(),
    };
};

export const getIdJwtToken = async () => {
    const { idToken } = await getSessionTokens();
    return idToken;
};
